import { UzCombobox } from '@utazzo/ui';

import { usePickerOptions } from './usePickerOptions';

import * as roomTypesApi from '@/features/room-types/room-types.api';

interface RoomTypePickerProps {
  label?: string;
  value: string | null;
  onValueChange: (value: string | null) => void;
  required?: boolean;
  disabled?: boolean;
  error?: string;
  hint?: string;
}

export const RoomTypePicker = ({
  label = 'Room type',
  value,
  onValueChange,
  required,
  disabled,
  error,
  hint,
}: RoomTypePickerProps): React.JSX.Element => {
  const { options, loading, setSearch } = usePickerOptions(
    {
      cacheKey: 'picker.roomTypes',
      fetch: async (search) => {
        const res = await roomTypesApi.listRoomTypes({
          page: 1,
          pageSize: 30,
          sortDir: 'asc',
          ...(search ? { search } : {}),
        });
        return res.data;
      },
      fetchOne: async (id) => {
        try {
          return await roomTypesApi.getRoomType(id);
        } catch {
          return null;
        }
      },
      toOption: (r) => ({
        value: r.id,
        label: r.name,
        description: r.code ?? undefined,
      }),
    },
    value,
  );

  return (
    <UzCombobox
      label={label}
      placeholder="Select a room type"
      searchPlaceholder="Search room types..."
      value={value ?? ''}
      onValueChange={(v) => onValueChange(v || null)}
      onSearchChange={setSearch}
      options={options}
      loading={loading}
      required={required}
      disabled={disabled}
      error={error}
      hint={hint}
    />
  );
};
